import React from 'react';
import PrePowerSkateProgramInfo from "../../Components/Front-End/Programs/PrePowerSkate/PrePowerSkateProgramInfo";
import Banner from "../../Components/Front-End/Banner/Banner";
import BannerImg from "../../assets/Banners/can-power-skate-banner.webp";
import {PrePowerSkateHeader} from "../../Components/Front-End/Programs/PrePowerSkate/PrePowerSkateHeader";

const  PrePowerSkatePage = () => {
    return (
        <div>
            <Banner
                heading="PrePower"
                description="Pre-CanPower is designed for skaters who are not yet ready to join a full PowerSkate session. The program follows the same fundamental “learn-to-skate” skills as a CanSkate session, with an added focus on developing the power, control, and agility skills required for hockey or ringette."
                image={{
                    src: BannerImg,
                    alt: "Executive Team Image"
                }}
            />
            <PrePowerSkateHeader/>
            <PrePowerSkateProgramInfo/>
        </div>
    );
};

export default PrePowerSkatePage;
